import Search from "@arcgis/core/widgets/Search";
import React, { useEffect, useRef } from "react";
import { observerAddToHandles } from "../../../handles/Handles";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import MapView from "@arcgis/core/views/MapView";
import SceneView from "@arcgis/core/views/SceneView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import LocatorSearchSource from "@arcgis/core/widgets/Search/LocatorSearchSource.js";

interface SearchWidgetProps  {
  view: MapView|SceneView
};
const SearchWidget = ({view}:SearchWidgetProps) => {
  const searchWidgetDiv = useRef(null);
  const extentLayerUrl = useRef(`https://www.ocgis.com/arcpub/rest/services/Map_Layers/City_Boundaries_Public/MapServer/0`);

  useEffect(() => {
    if (searchWidgetDiv.current) {
      const flagSymbol ={type: "picture-marker",url:`${process.env.PUBLIC_URL}/search-flag.png`,height:'50px',width:'50px'}
      const ocLocator=new LocatorSearchSource({
        name:"Address, street, or intersection",
        placeholder: "Find address,street, or intersection",
        resultSymbol: flagSymbol as any,
        url:"https://www.ocgis.com/arcpub/rest/services/Geocode/OC_Locator/GeocodeServer"
      })
      let searchWidget;
 //     createSources(view).then((viewSources) => {
        searchWidget = new Search({
          container: searchWidgetDiv.current,
          view: view,
          allPlaceholder: "Search address, intersection, layer, or street",
          includeDefaultSources: true,
   //       sources: viewSources,
        });
                view.ui.add(searchWidget, "top-right");
        observerAddToHandles(
            reactiveUtils.once(
              () => searchWidget.defaultSources.length)
              .then((e)=>{
                if(e>0){
                  searchWidget.defaultSources.forEach(src=>{
                  if(!src.hasOwnProperty('layer')){
                    src.resultSymbol= flagSymbol as any
                    src.zoomScale=100
                  }else{
                    if(src.layer.geometryType==="multipoint" || src.layer.geometryType==="point"){
                      src.zoomScale=100
                    }
                  }
                  if(src.name.length>0){
                    if(src.name==="ArcGIS World Geocoding Service"){
                    src.countryCode='US'
                    src.name='Address ArcGIS world locator'
                    let extentLayer= new FeatureLayer({url:extentLayerUrl.current})
                    extentLayer.queryExtent().then(result=>{
                      src.filter={geometry:result.extent}
                    })
                  }
                    searchWidget.sources.add(src)
                  
                  }
                  })
                  searchWidget.sources.add(ocLocator);
                  searchWidget.sources.sort((a,b)=>a.name.localeCompare(b.name))
                  searchWidget.includeDefaultSources=false
                }      
              }
            ),
            "searchDefaultSourcesLength"
          );
      return () => {
        searchWidget.destroy();
      };
    }
  }, []);

  return <div ref={searchWidgetDiv}></div>;
};
export default SearchWidget;

